export default __webpack_public_path__ + "static/media/KOD0134-min.197008b5.webp";